import React, { Component } from "react";
import {
    isSimilarObject
} from '../../helper';

export default class WorkUploadButton extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    uploadWorks(e) {
        e.preventDefault();
        this.props.uploadWorks(e)
    }

    render() {
        const {
            isVideo,
            btnDisable,
            inputTypeFileValue,
            uploadState,
            allow_upload_only_mp4,
        } = this.props;

        if(btnDisable) return false;

        return  (
            <li className={`add-example ${uploadState ? 'loading-for-upload-button' : ''}`}>
                <div className="img"></div>

                <input
                    type="file"
                    value={inputTypeFileValue}
                    disabled={(uploadState) ? true : false}
                    className="add-example__input"
                    accept={isVideo ? allow_upload_only_mp4 ? "video/mp4" : "video/*" : "image/jpeg,image/png,image/gif"}
                    onChange={this.uploadWorks.bind(this)}
                    />
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/WorkUploadButton.js